<template>
    <section class="step-item step-groups">
        <section class="step-item__title">
            <h2>Administratorzy</h2>
        </section>
        <section class="step-item__body">
            <section class="step-item__body__item flex-column">
                <p>Wybierz administratorów, którzy mają mieć takie same uprawienia w nowej kadencji <span class="limits" :class="{'limit-error': canAddAdministrator === false}">({{getCurrentUseLicenses}}/{{getAdminiLicenses}})</span> </p>
                <section class="available-users d-flex flex-row flex-wrap justify-content-center gap-2">

                    <AdministratorItem v-for="(item, index) in getAdministrators"
                                       :key="index"
                                       :item="item"
                                       @click="userClicked(item)"
                                       :isOutOfLicence="getCurrentUseLicenses >= getAdminiLicenses"
                                       :selected="$store.state.wizardNewCadence.selectedAdministrators.includes(item.id)" />
                </section>
                <br />
                <p>Przeniesieni administratorzy będą mogli się logować dotychczasowymi danymi dostępowymi w nowej kadencji.</p>
                <p>Zostanie również utworzone dodatkowe konto do logowania w starej kadencji.</p>
            </section>
        </section>
        <section class="step-item__footer">
            <ButtonWithIcon :icon="'additional-arrow'" :text="'Wstecz'" class="btn-step-item btn-reverse" @click="movePrev" />
            <ButtonIconAppend :icon="'additional-arrow'" class="btn-step-item" @click="moveNext">
                Dalej
            </ButtonIconAppend>
        </section>
    </section>
</template>
<script charset="utf-8">
    import wizardNewCadenceService from "../../../../services/wizard.new.cadence.service";
    import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue";
    import ButtonIconAppend from "../../../BasicControls/ButtonIconAppend.vue";
    import AdministratorItem from "../components/AdministratorItem.vue";

    export default {
        name: "Step3Administrators",
        components: {
            ButtonWithIcon,
            ButtonIconAppend,
            AdministratorItem
        },
        computed: {
            getAdministrators() {
                return this.$store.state.wizardNewCadence.availableAdministrators;
            },

            getAdminiLicenses() {
                return this.$store.state.wizardNewCadence.availableAdminlicences;
            },

            getCurrentUseLicenses() {
                return this.$store.state.wizardNewCadence.selectedAdministrators.length;
            },

            canAddAdministrator() {
                return this.getCurrentUseLicenses <= this.getAdminiLicenses;
            },

            isStepIsDone() {
                return this.$store.state.wizardNewCadence.stepsDone.includes(3);
            },

            currentUser() {
                return this.$store.state.userStore.userData;
            }
        },
        async mounted() {
            try {
                this.$store.commit("setWizardNewCadenceBusyStatus", true);
                this.$store.commit("setWizardNewCadenceCurrentStep", 3);
                await this.internalFetchAvailableAdministrators();
                await this.internalFetchAvailableAdministratorsLicense();
                this.selectCurrentAdministrator();
            }
            finally {
                this.$store.commit("setWizardNewCadenceBusyStatus", false);
            }
        },
        methods: {
            async internalFetchAvailableAdministrators() {
                let response = await wizardNewCadenceService.getClientAdministrators();
                if (response.status === 200)
                    this.$store.state.wizardNewCadence.availableAdministrators = response.data;

            },

            async internalFetchAvailableAdministratorsLicense() {
                let response = await wizardNewCadenceService.getAvailableAdminLicenses();
                if (response.status === 200)
                    this.$store.state.wizardNewCadence.availableAdminlicences = response.data;
            },

            async moveNext() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    this.$store.commit("setWizardNewCadenceStepsDone", 3);
                    await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 4 } });
                    this.$store.commit("setWizardNewCadenceCurrentStep", 4);
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            },

            async movePrev() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    if (this.$store.state.wizardNewCadence.clientHasTransmission) {
                        await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 1 } });
                        this.$store.commit("setWizardNewCadenceCurrentStep", 1);
                    }
                    else {
                        await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 1 } });
                        this.$store.commit("setWizardNewCadenceCurrentStep", 1);
                    }
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            },

            selectCurrentAdministrator() {
                try {
                    if (this.isStepIsDone === true)
                        return;

                    let filteredAvailableAdmins = this.getAdministrators.filter(item => item.lid === this.currentUser.id);
                    if (filteredAvailableAdmins.length === 0)
                        return;

                    this.$store.state.wizardNewCadence.selectedAdministrators.push(filteredAvailableAdmins[0].id);
                }
                catch (e) {
                    console.log(e);
                }
            },

            userClicked(obj) {
                if (obj === undefined || obj === null) {
                    return;
                }

                if (this.$store.state.wizardNewCadence.selectedAdministrators.includes(obj.id)) {
                    // jest
                    this.$store.state.wizardNewCadence.selectedAdministrators = this.$store.state.wizardNewCadence.selectedAdministrators.filter(item => item !== obj.id);
                }
                else {

                    if (this.getCurrentUseLicenses >= this.getAdminiLicenses) {
                        return;
                    }

                    this.$store.state.wizardNewCadence.selectedAdministrators.push(obj.id);
                }
            }
        }
    }
</script>
<style lang="scss">
    @import "@/assets/scss/wizard-generic-step.scss";
</style>
